<div #wrapper>
  <app-general-header></app-general-header>

  <section aria-label="main" role="main" id="main-content">
    <article class="container">
      <div class="center-column">
        <h1 class="text-light-black dark:text-white">
          {{ 'unauthorized.thanksForYourInterestInCrowdtap' | translate }}&reg;.
        </h1>
        <p
          [innerHTML]="'unauthorized.unfortunatelyCrowdtap' | translate"
          class="text-light-black dark:text-white"
        ></p>
        <p class="text-light-black dark:text-white">
          {{ 'unauthorized.weHopeToExpandToMoreCountriesSoon' | translate }}
        </p>
      </div>
    </article>
  </section>

  <app-general-footer> </app-general-footer>
</div>
